import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/runner/work/build-a-dress/build-a-dress/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/home/runner/work/build-a-dress/build-a-dress/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ResourceHints"] */ "/home/runner/work/build-a-dress/build-a-dress/src/components/layout/ResourceHints.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouteAwareShell"] */ "/home/runner/work/build-a-dress/build-a-dress/src/components/layout/RouteAwareShell.tsx");
